import { boolean, nativeEnum, object, TypeOf } from 'zod';

import { Alignment, CornerStyle, Ratio, TileSize } from '../common';

/* ------------------------------- TileOptions ------------------------------ */

export const TileOptions = object({
    alignment: nativeEnum(Alignment),
    name: object({
        alignment: nativeEnum(Alignment),
        visible: boolean(),
    }),
    description: object({
        alignment: nativeEnum(Alignment),
        visible: boolean(),
    }),
    image: object({
        size: nativeEnum(TileSize),
        ratio: nativeEnum(Ratio),
        cornerStyle: nativeEnum(CornerStyle),
    }),
    focus: object({
        border: boolean(),
        shadow: boolean(),
    }),
    duration: object({
        visible: boolean(),
        displaySeconds: boolean(),
    }),
    published: object({
        visible: boolean(),
    }),
    progressBar: object({
        visible: boolean(),
    }),
    ageRating: object({
        visible: boolean(),
    }),
    releaseDate: object({
        visible: boolean(),
    }),
});

export type TileOptions = TypeOf<typeof TileOptions>;
